import { render, staticRenderFns } from "./WOTile.vue?vue&type=template&id=5b389baf&scoped=true&"
import script from "./WOTile.vue?vue&type=script&lang=js&"
export * from "./WOTile.vue?vue&type=script&lang=js&"
import style0 from "./WOTile.vue?vue&type=style&index=0&id=5b389baf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b389baf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBadge,VBtn,VCard,VIcon,VTooltip})
